// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { IsEmpty } from '../../common/checks';
import MText from '../common/MText';

// ============================================================
// EMPTY STATE
// ============================================================

const EmptyState = ({
  title,
  description,
}) => (
  <Box
    height="100%"
    minHeight={250}
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <MText
      variant="body2"
      style={{
        color: '#888',
      }}
    >
      {title}
    </MText>

    {!IsEmpty(description) && (
      <MText
        variant="caption"
        style={{
          color:     '#aaa',
          marginTop: 4,
        }}
      >
        {description}
      </MText>
    )}
  </Box>
);

EmptyState.propTypes = {
  title:       PropTypes.string.isRequired,
  description: PropTypes.string,
};

EmptyState.defaultProps = {
  description: '',
};

export default EmptyState;
